/**
 * https://github.com/michu2k/Accordion#readme
 */
import { hellopanda_func as $ } from '../../../assets/script/func.js';

const HELLOPANDA_ACCORDION = {
  init: function() {

    let Accordion;
    try {
      Accordion = require("accordion-js");
    } catch (error) {
      console.warn("accordion-js module not found, the accordion-js effect is disabled.");
    }
    
    if (typeof Accordion === 'function') {
      document.addEventListener("DOMContentLoaded", function () {
        
        // 모든 아코디언 블록을 선택
        const accordionBlocks = document.querySelectorAll('.wp-block-hellopanda-accordion-block');

        // 각 아코디언 블록에 대해 Accordion 초기화
        accordionBlocks.forEach((accordionBlock) => {
          const duration = parseInt(accordionBlock.getAttribute('data-duration'), 10);
          const showMultiple = accordionBlock.getAttribute('data-show-multiple') === 'true';
          const accordionItems = accordionBlock.querySelectorAll('.wp-block-hellopanda-accordion-item-block');

          // 아코디언 내부에 없는 요소 강제 생성
          accordionItems.forEach((item, index) => {
            let item_trigger = [...item.children].find(el => el.matches('.wp-block-hellopanda-accordion-item-block-trigger'));
            let item_panel = [...item.children].find(el => el.matches('.wp-block-hellopanda-accordion-item-block-panel'));
            if (!item_trigger) {
              item_trigger = document.createElement('div');
              item_trigger.className = 'wp-block-hellopanda-accordion-item-block-trigger';
              item.appendChild(item_trigger);
            }
            if (!item_panel) {
              item_panel = document.createElement('div');
              item_panel.className = 'wp-block-hellopanda-accordion-item-block-panel';
              item.appendChild(item_panel);
            }
          });

          // 열린 상태의 인덱스를 추출하는 함수
          const getOpenIndices = () => {
            const indices = [];
            accordionItems.forEach((item, index) => {
              const isOpened = item.getAttribute('data-opened') === 'true';
              if (isOpened) {
                indices.push(index);
              }
            });

            // 아코디언 준비 완료
            accordionBlock.classList.add('wp-block-hellopanda-accordion-block-ready');

            return indices;
          };

          // 객체 생성
          new Accordion(accordionBlock, {
            elementClass: 'wp-block-hellopanda-accordion-item-block',
            triggerClass: 'wp-block-hellopanda-accordion-item-block-trigger',
            panelClass: 'wp-block-hellopanda-accordion-item-block-panel',
            activeClass: 'wp-block-hellopanda-accordion-item-block-active',
            duration: duration,
            showMultiple: showMultiple,
            openOnInit: getOpenIndices(),
            onlyChildNodes: true
          });
    
          /**
           * 자식의 스타일을 가상의 설정
           */
          const style = document.createElement('style');
          const hoverStyles = new Map();
          const activeStyles = new Map();
    
          accordionBlock.querySelectorAll('& > .wp-block-hellopanda-accordion-item-block').forEach((element) => {
            const hoverText = element.getAttribute('data-hoverText');
            const hoverBackground = element.getAttribute('data-hoverBackground');
            const hoverBorder = element.getAttribute('data-hoverBorder');
            const hoverFontWeight = element.getAttribute('data-hoverFontWeight');
            const activeText = element.getAttribute('data-activeText');
            const activeBackground = element.getAttribute('data-activeBackground');
            const activeBorder = element.getAttribute('data-activeBorder');
            const activeFontWeight = element.getAttribute('data-activeFontWeight');
    
            let hoverClass = null;
            let activeClass = null;
    
            // Generate hover styles and class if necessary
            if (hoverText || hoverBorder || hoverBackground || hoverFontWeight) {
              const hoverKey = `${hoverText}-${hoverBorder}-${hoverBackground}`;
    
              if (hoverStyles.has(hoverKey)) {
                hoverClass = hoverStyles.get(hoverKey);
              } else {
                hoverClass = $.randomOnlyString(20); // Use your custom random string generator
                hoverStyles.set(hoverKey, hoverClass);
                
                style.innerHTML += `
                  .${hoverClass}:hover > .wp-block-hellopanda-accordion-item-block-trigger {
                    ${hoverText ? `color: ${hoverText} !important;` : ''}
                    ${hoverBorder ? `border-color: ${hoverBorder} !important;` : ''}
                    ${hoverBackground ? `background-color: ${hoverBackground} !important;` : ''}
                    ${hoverFontWeight ? `font-weight: ${hoverFontWeight} !important;` : ''}
                  }
                `;
              }
              element.classList.add(hoverClass);
            }
    
            // Generate active styles and class if necessary
            if (activeText || activeBorder || activeBackground || activeFontWeight) {
              const activeKey = `${activeText}-${activeBorder}-${activeBackground}`;
    
              if (activeStyles.has(activeKey)) {
                activeClass = activeStyles.get(activeKey);
              } else {
                activeClass = $.randomOnlyString(20); // Use your custom random string generator
                activeStyles.set(activeKey, activeClass);
                
                style.innerHTML += `
                  .wp-block-hellopanda-accordion-item-block-active.${activeClass} > .wp-block-hellopanda-accordion-item-block-trigger {
                    ${activeText ? `color: ${activeText} !important;` : ''}
                    ${activeBorder ? `border-color: ${activeBorder} !important;` : ''}
                    ${activeBackground ? `background-color: ${activeBackground} !important;` : ''}
                    ${activeFontWeight ? `font-weight: ${activeFontWeight} !important;` : ''}
                  }
                `;
              }
              element.classList.add(activeClass);
            }
          });
    
          // Minify the CSS before appending
          style.innerHTML = style.innerHTML.replace(/\s+/g, ' ').trim();
          accordionBlock.appendChild(style);
    
        });
    
      });
    }

  }
};
HELLOPANDA_ACCORDION.init();